/**
 * Regex that matches markdown-style mention links of the form [Name](id)
 * optionally followed by non-word, non-whitespace, non-bracket characters (e.g. punctuation).
 *
 * Capture groups:
 *   1 - name  (the display text inside [...])
 *       [^\]]+ matches any sequence of one or more characters that does not contain
 *       a closing square bracket
 *   2 - id    (the value inside (...))
 *       [^)]+ matches one or more characters that are not a closing parenthesis )
 *   3 - trailing punctuation after the closing parenthesis
 *       [^\w\s[]* matches zero or more consecutive characters that are NOT alphanumeric
 *       characters, underscores, whitespace, or opening square brackets.
 */
export const MENTION_LINK_REGEX = /\[([^\]]+)\]\(([^)]+)\)([^\w\s[]*)/g;

/**
 * Replaces markdown-style mention links in `content` with plain URLs of the
 * form `<host>/people/<id>`, and records each id→name mapping in `mentionMap`.
 *
 * @param {string} content - The raw markdown string to process.
 * @param {Map<string, string>} mentionMap - A Map that will be populated with
 *   id → name entries for every mention found in `content`.
 * @returns {string} The processed string with mention links replaced by URLs.
 */
export const replaceMentionLinks = (content, mentionMap) =>
  content.replace(MENTION_LINK_REGEX, (_, name, id, trailing) => {
    mentionMap.set(id, name);
    return `${window.location.host}/people/${id}${trailing} `;
  });
